import { Aggregate } from 'Types/Aggregates';
import Filter from 'Types/Filter';

export const celciusToKelvin = (val: number | string) =>
  val ? parseInt(val.toString(), 10) + 273.15 : 0;
export const kelvinToCelcius = (val: number | string) =>
  val ? parseInt(val.toString(), 10) - 273.15 : 0;

export const getFilterValue = (
  aggregate: Aggregate,
  inputs: any,
  param: 'discharge_filter' | 'supply_filter'
): string => {
  let filters: Filter[] = [];
  if (param === 'discharge_filter') {
    filters = aggregate?.discharge_filters || [];
  } else {
    filters = aggregate?.supply_filters || [];
  }

  const filter = filters?.find((f) => f.id === inputs[param]);
  return filter?.category || filters[0]?.category;
};

export const splitArrayInChunks = (a: Array<any>, n: number) =>
  [...Array(Math.ceil(a.length / n))].map((_, i) =>
    a.slice(i * n, (i + 1) * n)
  );

export const delay = (d = 1000): Promise<void> =>
  // eslint-disable-next-line no-promise-executor-return
  new Promise((res) => setTimeout(() => res(), d));
